import { ContextMenuItem, KBD } from '@seen/ui'
import { IconExternalLink } from '@tabler/icons-react'
import type { ReactNode } from 'react'

export interface ContextMenuOpenInNewTabProps {
  href: string
}

export function ContextMenuOpenInNewTab({
  href,
}: ContextMenuOpenInNewTabProps): ReactNode {
  return (
    <ContextMenuItem asChild>
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2"
      >
        <IconExternalLink className="-mt-px size-4 text-foreground-secondary" />
        Open in new tab
        <div className="flex gap-1">
          <KBD>⌘</KBD>
          <KBD>click</KBD>
        </div>
      </a>
    </ContextMenuItem>
  )
}
